import { createSlice } from '@reduxjs/toolkit';
import LegalRisk from '../Risk/LegalRiskCriteria'
import FinancialRisk from '../Risk/FinancialRiskCriteria'

const initialState = {
  legalScores: {},
  legalRationales: {},
  legalLabels: {},
  legalColors: {},
  legalAssessments: {},
  legalDescriptions: {},
  financialScores: {},
  financialRationales: {},
  financialLabels: {},
  financialColors: {},
  financialAssessments: {},
  financialDescriptions: {}
};

const riskSlice = createSlice({
  name: 'risk',
  initialState,
  reducers: {
    setLegalScore: (state, action) => {
      const { factor, value } = action.payload;
      const factorData = LegalRisk.riskFactors.find(f => f.factor === factor);
      const criteria = factorData ? factorData.criteria.find(c => c.value == value) : null;
      state.legalScores[factor] = value;
      state.legalLabels[factor] = criteria ? criteria.label : 'No label';
      state.legalColors[factor] = criteria ? criteria.color : '#000';
      state.legalRationales[factor] = state.legalRationales[factor] || (criteria ? criteria.rationale : 'No rationale provided'); // Use existing rationale or default
      state.legalAssessments[factor] = LegalRisk.getRiskLevel(value)?.description || 'No assessment available';
      state.legalDescriptions[factor] = criteria ? criteria.description : 'No description available';
    },
    setLegalRationale: (state, action) => {
      const { factor, value } = action.payload;
      state.legalRationales[factor] = value;
    },
    setFinancialScore: (state, action) => {
      const { factor, value } = action.payload;
      const factorData = FinancialRisk.riskFactors.find(f => f.factor === factor);
      const criteria = factorData ? factorData.criteria.find(c => c.value == value) : null;
      state.financialScores[factor] = value;
      state.financialLabels[factor] = criteria ? criteria.label : 'No label';
      state.financialColors[factor] = criteria ? criteria.color : '#000';
      state.financialRationales[factor] = state.financialRationales[factor] || (criteria ? criteria.rationale : 'No rationale provided'); // Use existing rationale or default
      state.financialAssessments[factor] = FinancialRisk.getRiskLevel(value)?.description || 'No assessment available';
      state.financialDescriptions[factor] = criteria ? criteria.description : 'No description available';
    },
    setFinancialRationale: (state, action) => {
      const { factor, value } = action.payload;
      state.financialRationales[factor] = value;
    },
    resetLegalScores: (state) => {
      state.legalScores = {};
      state.legalLabels = {};
      state.legalColors = {};
      state.legalRationales = {};
      state.legalAssessments = {};
      state.legalDescriptions = {};
    },
    resetFinancialScores: (state) => {
      state.financialScores = {};
      state.financialLabels = {};
      state.financialColors = {};
      state.financialRationales = {};
      state.financialAssessments = {};
      state.financialDescriptions = {};
    }
  }
});

export const { setLegalScore, setLegalRationale, setFinancialScore, setFinancialRationale, resetLegalScores, resetFinancialScores } = riskSlice.actions;

export default riskSlice.reducer;
